(function () {
  'use strict';

  // Fully self-contained: no shared state with any other section's JS, no
  // cart/variant logic — just toggles the same overlay the desktop :hover
  // CSS rule reveals (via .is-open on the card, since mobile has no real
  // hover) and drives the desktop prev/next arrow buttons.

  function initToggles(section) {
    const cards = Array.from(section.querySelectorAll('[data-kic-card]'));
    cards.forEach((card) => {
      const toggle = card.querySelector('[data-kic-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        card.classList.toggle('is-open', !isOpen);
      });
    });
  }

  function initArrows(carousel) {
    const track = carousel.querySelector('[data-kic-track]');
    const prev = carousel.querySelector('[data-kic-prev]');
    const next = carousel.querySelector('[data-kic-next]');
    if (!track || !prev || !next) return;

    function scrollStep() {
      const card = track.querySelector('[data-kic-card]');
      return card ? card.getBoundingClientRect().width + 32 : track.clientWidth * 0.8;
    }

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });

    function updateArrowState() {
      const hasOverflow = track.scrollWidth > track.clientWidth + 1;
      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      if (!hasOverflow) return;
      const atStart = track.scrollLeft <= 1;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      prev.disabled = atStart;
      next.disabled = atEnd;
      prev.style.opacity = atStart ? '.4' : '1';
      next.style.opacity = atEnd ? '.4' : '1';
    }

    track.addEventListener('scroll', updateArrowState);
    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  }

  document.querySelectorAll('.kic').forEach((section) => {
    initToggles(section);
    const carousel = section.querySelector('[data-kic-carousel]');
    if (carousel) initArrows(carousel);
  });
})();
